"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINANCIAL_APPROVAL_REQUEST_EXAMPLES = exports.resolveApprovalChainRequestSchema = void 0;
/**
 * Request contract for the 1 Approval endpoint —
 * `ApprovalApplicationService.resolveApprovalChain`
 * (`backend/src/modules/financial/application/approval.application-service.ts`,
 * frozen, Stage 5C.3). Chain RESOLUTION only — no approval-state
 * tracking exists anywhere in the codebase (Stage 5C.2's own
 * disclosed boundary, unchanged); this contract cannot express "has
 * this approval happened," only "who must approve, in what order."
 */
const zod_1 = require("zod");
const financial_common_request_1 = require("./financial-common.request");
exports.resolveApprovalChainRequestSchema = zod_1.z.object({
    moduleName: zod_1.z.string().min(1),
    actionName: zod_1.z.string().min(1),
    options: financial_common_request_1.financialCallOptionsSchema.optional(),
});
exports.FINANCIAL_APPROVAL_REQUEST_EXAMPLES = {
    resolveApprovalChain: {
        moduleName: 'financial-discount',
        actionName: 'apply-discount',
    },
};
//# sourceMappingURL=financial-approval.request.js.map